import randomIdGenerator from './randomIdGenerator';

window.analyticsPageTimer = 0;
window.mesureWebPerformanceStart = true;
const deployEnv = process.env.ACARA_DEPLOY_ENV;

const protocol = deployEnv === 'production' ?  'https://analytics.acara.io' : deployEnv === 'staging' ? 'https://staginganalytics.acara.io' : 'http://localhost:3000';


window.pageSessionId = randomIdGenerator();
window.blurAnalyticsState = false;

const userAgent =  window.navigator.userAgent;
const isBot = /(bot|spider|crawl|googlebot|bingbot|yandexbot|duckduckgo|slurp|baiduspider|ia_archiver|facebookexternalhit|twitterbot)/i.test(userAgent)

const guessTimezoneAnalytics = Intl.DateTimeFormat().resolvedOptions().timeZone;

let lastPageData;

window._analyticsPageTimerInterval = setInterval(() => {
  if (document.hidden) return;
  window.analyticsPageTimer = window.analyticsPageTimer + 1000;
}, 1000);



// function resetSessionTimer() {
//   if (window._analyticsPageTimerInterval) clearInterval(window._analyticsPageTimerInterval);
//   window.analyticsPageTimer = 0;
//   window._analyticsPageTimerInterval = setInterval(() => {
//     if (document.hidden || document.visibilityState !== 'visible') return;
//     window.analyticsPageTimer = window.analyticsPageTimer + 1000;
//   }, 1000);
// }

function sendAnalyticsFecth(thisPayload) {
  fetch(protocol+'/analytics', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    mode: 'cors',
    body: JSON.stringify(thisPayload),
    keepalive: true
  }).then(response => {
    window.blurAnalyticsState = false;
    return response.json().then(responseData => {
      if (responseData.anonUserIdString) anonUserIdString = responseData.anonUserIdString;
      return;
    });
  }).catch(function (err) {
    window.blurAnalyticsState = false;
    console.log(err);
  });
}

// function sendAnalyticsData(thisPayload) {
  
//   try {
//     if(navigator.sendBeacon) {
//       navigator.sendBeacon(protocol+'/analytics', JSON.stringify(thisPayload));

//       return 'dupa';
//     }     
//     sendAnalyticsFecth(thisPayload);
//   } catch(e) {
//     console.log(e)
//     if (navigator.sendBeacon) sendAnalyticsFecth(thisPayload);
//   }

// }

export default function handleAnalytics(props = {}, initial, event, end) {

  if (isBot) return;

  const thisEventData = props.eventData ? props.eventData : window.eventData;
  const templateSchema = thisEventData?.template?.templateSchema;
  const organizationData = thisEventData?.template?.organizationData;

  const isSamePage = document.referrer && window.location.origin == new URL(document.referrer).origin;

  let isExternalReferrer = isSamePage ? null : document.referrer ? document.referrer : null;

  let paramsList;

  const thisLocationHref = props.href ? props.href : window.location.href;

  const urlSearch = new URLSearchParams(window.location.search);

  if (urlSearch) {
    paramsList = {};
    urlSearch.forEach(function (val, key) {
      if (key.includes('utm_') || key.includes('ref')) paramsList[key] = val;
    });  
  }


  const thisPayload = {
    templateId: props.templateId ? props.templateId : templateSchema?.templateId,
    organizationId: props.organizationId ? props.organizationId : organizationData?.organizationId,
    domain: window.location.hostname,
    slug: props.pageSlug,
    pageId: props?.currentPage,
    referrer: isExternalReferrer,
    location: thisLocationHref.split('?')[0],
    type: !isSamePage || isExternalReferrer ? 'initialview' : 'pageview',
    pageTitle: props.title ? props.title : document.title,
    pagePath: props.pagePath ? props.pagePath : window.location.pathname,
    timezone: guessTimezoneAnalytics,
    params: paramsList,
    version: 3,
    pageSessionId: window.pageSessionId
  };



  if (!lastPageData) {
    // window.pageSessionId = randomIdGenerator();
    // thisPayload.pageSessionId = window.pageSessionId;
    lastPageData = thisPayload;
  }


    thisPayload.timeOnPage = analyticsPageTimer >= 0 ? analyticsPageTimer : 0;
    if (mesureWebPerformanceStart && thisPayload.timeOnPage) {
      thisPayload.pageLoadTime = parseInt(performance.getEntriesByType('navigation')[0].duration);
      mesureWebPerformanceStart = false;
    }





  sendAnalyticsFecth(thisPayload);

}



function handleBlurAnalytics(type) {
  if (!window.blurAnalyticsState && document.hidden) {
    if (lastPageData) {
      window.blurAnalyticsState = true;
      handleAnalytics(lastPageData, false, null, true, window.blurAnalyticsState);
    }    
  }
}

document.addEventListener('visibilitychange', handleBlurAnalytics);
window.addEventListener('blur', handleBlurAnalytics);
